module.exports = __webpack_public_path__ + "img/menu_create_icon_only.26008bc1.png";